import React from 'react'
import { connect } from 'react-redux'
import { Box } from 'components/Layout'
import { Button } from 'components/Button'
import { BoxShell } from 'components/Shells'

import history from '../../history'

class AppStatsContainer extends React.Component {
	appSubPath(path) {
		return '/apps/' + this.props.appId + '/' + path
	}

	render() {
		const { app, appId, isAppPublished } = this.props

		if (typeof app === 'undefined') {
			return <BoxShell height={150} />
		}
		const appSubPath = path => '/apps/' + appId + '/' + path
		return isAppPublished ? (
			<Box
				header={'App installations'}
				body={
					"This app is published and available in the Apps Marketplace. We are monitoring and collecting the number of installations. You'll soon see the statistics here."
				}
				bodyPadding
			/>
		) : (
			<Box
				header={'App installations'}
				body={
					'This app is currently in the development mode. It means only your team can use it. We will soon release an update that allows you to publish apps for all chat.io users.'
				}
				bodyPadding
				footer={
					<span>
						<Button
							type={'ghost'}
							onClick={e => {
								history.push(appSubPath('distribution'))
							}}
						>
							{'Set up distribution'}
						</Button>
					</span>
				}
			/>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const currentAppId = ownProps.appId
	const currentApp = state.apps.items[currentAppId]

	// const isAppInReview =
	// 	typeof currentApp !== 'undefined'
	// 		? currentApp.status === 'IN_REVIEW'
	// 		: false

	const isAppPublished =
		typeof currentApp !== 'undefined'
			? currentApp.status === 'PUBLISHED'
			: false

	return {
		app: currentApp,
		isAppPublished
		// isAppInReview
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AppStatsContainer)



// WEBPACK FOOTER //
// ./src/containers/AppStats/AppStats.js